import { render, staticRenderFns } from "./DeQueue.vue?vue&type=template&id=667e0d30&scoped=true&"
import script from "./DeQueue.vue?vue&type=script&lang=js&"
export * from "./DeQueue.vue?vue&type=script&lang=js&"
import style0 from "./DeQueue.vue?vue&type=style&index=0&id=667e0d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e0d30",
  null
  
)

export default component.exports